export default function NotAuthorized() {
  return (
    <div style={{ textAlign: 'center', marginTop: '3em' }}>
      <h2>Not Authorized</h2>
      <p>You do not have permission to view this page.</p>
    </div>
  );
}
